'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveId$() {
  this.c4O = null;
  this.c4P = false;
  this.c4M = null;
  this.c4N = false;
}
export { $c_Lpresto_types$DirectiveId$ as $c_Lpresto_types$DirectiveId$ };
$p = $c_Lpresto_types$DirectiveId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveId$;
/** @constructor */
function $h_Lpresto_types$DirectiveId$() {
}
export { $h_Lpresto_types$DirectiveId$ as $h_Lpresto_types$DirectiveId$ };
$h_Lpresto_types$DirectiveId$.prototype = $p;
$p.adj = (function() {
  if ((!this.c4P)) {
    this.c4O = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j1;
    this.c4P = true;
  }
  return this.c4O;
});
$p.v4 = (function() {
  if ((!this.c4N)) {
    this.c4M = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB;
    this.c4N = true;
  }
  return this.c4M;
});
var $d_Lpresto_types$DirectiveId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveId$, "presto.types$DirectiveId$", ({
  ZS: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveId$ as $d_Lpresto_types$DirectiveId$ };
var $n_Lpresto_types$DirectiveId$;
function $m_Lpresto_types$DirectiveId$() {
  if ((!$n_Lpresto_types$DirectiveId$)) {
    $n_Lpresto_types$DirectiveId$ = new $c_Lpresto_types$DirectiveId$();
  }
  return $n_Lpresto_types$DirectiveId$;
}
export { $m_Lpresto_types$DirectiveId$ as $m_Lpresto_types$DirectiveId$ };
//# sourceMappingURL=presto.types$-Directive-Id$.js.map
